
import { defineComponent } from "vue"
import MatchGameRecordsIndex from "@/components/match_game_records/Index.vue"

export default defineComponent({
  components: {
    MatchGameRecordsIndex
  }
})
